import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Router } from '@angular/router';
import { GlobalService } from '../global.service';
@Injectable()
export class BuyerInvoiceService {

	constructor(private http: Http, private router: Router) { }

	public listInvoice() {
		console.log('inside services');
		return this.http.get(environment.baseUrl + '/buyer/invoice', GlobalService.getHeaders()).map((response: Response) => {
			console.log(response.status);
			const user = response.json();
			user.responseStatus = response.status;
			console.log(user);
			return user;
		}).catch((error) => {
			console.log('error', error);
			if (error.status === 500) {
				console.log('status', error.status);
				const err = error.json();
				err.responseStatus = error.status;
				console.log('status', err.responseStatus);
				return Observable.throw(err);
			} else if (error.status === 400) {
				console.log('status', error.status);
				const err = error.json();
				err.responseStatus = error.status;
				console.log('status', err.responseStatus);
				return Observable.throw(err);
			} else if (error.status === 401) {
				console.log('status', error.status);
				const err = error.json();
				err.responseStatus = error.status;
				console.log('status', err.responseStatus);
				return Observable.throw(err);
			}
		});
	}


	public filterInvoice(buyerInvID: any) {
		console.log('inside services');
		const invoiceId = buyerInvID;
		const sellerId = sessionStorage.getItem('invoiceSellerID');
		return this.http.get(environment.baseUrl + '/buyer/invoice/' + sellerId + '/' + invoiceId,
			GlobalService.getHeaders()).map((response: Response) => {
				console.log(response.status);
				const user = response.json();
				user.responseStatus = response.status;
				console.log(user);
				return user;
			}).catch((error) => {
				console.log('error', error);
				if (error.status === 500) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 400) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 401) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				}
			});
	}

	public getInvoiceById(invoiceId) {
		console.log('inside services');
		const invId = invoiceId;
		const sellerId = sessionStorage.getItem('buyerBOESellerId');
		return this.http.get(environment.baseUrl + '/buyer/invoice/' + sellerId + '/' + invId,
			GlobalService.getHeaders()).map((response: Response) => {
				console.log(response.status);
				const user = response.json();
				user.responseStatus = response.status;
				console.log(user);
				return user;
			}).catch((error) => {
				console.log('error', error);
				if (error.status === 500) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 400) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 401) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				}
			});
	}

	public acceptInvoice(acceptancecriteria) {
		const invoiceId = localStorage.getItem('buyerInvoiceId');
		const sellerId = sessionStorage.getItem('invoiceSellerID');
		const data = {
			'sellerId': sellerId,
			'invoiceId': invoiceId,
			'status': 'Accepted',
			'acceptanceCriteria': acceptancecriteria
		};
		console.log('data', data);
		const body = JSON.stringify(data);
		console.log(body);
		return this.http.post(environment.baseUrl + '/buyer/invoice', body,
			GlobalService.getHeaders()).map((response: Response) => {
				console.log(response.status);
				const user = response.json();
				user.responseStatus = response.status;
				console.log(user);
				return user;
			}).catch((error) => {
				console.log('error', error);
				if (error.status === 500) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 400) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 401) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				}
			});
	}

	public rejectInvoice(rejection, acceptancecriteria) {
		console.log('remarks', rejection.remarks);
		const invoiceId = localStorage.getItem('buyerInvoiceId');
		const sellerId = sessionStorage.getItem('invoiceSellerID');
		const data = {
			'sellerId': sellerId,
			'invoiceId': invoiceId,
			'status': 'Rejected',
			'rejectionRemarks': rejection.remarks,
			'acceptanceCriteria': acceptancecriteria
		};
		console.log('data', data);
		const body = JSON.stringify(data);
		console.log(body);
		return this.http.post(environment.baseUrl + '/buyer/invoice', body,
			GlobalService.getHeaders()).map((response: Response) => {
				console.log(response.status);
				const user = response.json();
				user.responseStatus = response.status;
				console.log(user);
				return user;
			}).catch((error) => {
				console.log('error', error);
				if (error.status === 500) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 400) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 401) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				}
			});
	}

	public makePayment(payment) {
		console.log('remarks', payment.amountPaid);
		console.log('invoiceamt', payment.invoiceId);
		const buyerId = localStorage.getItem('buyerId')
		const invoiceId = localStorage.getItem('buyerInvoiceId');
		const data = {
			'amountPaid': payment.amountPaid,
			'invoiceId': payment.invoiceId,
			'buyerId': buyerId,
			'referenceNumber': '456KL'
		};
		console.log('data', data);
		const body = JSON.stringify(data);
		console.log(body);
		return this.http.post(environment.baseUrl + '/buyer/payment', body,
			GlobalService.getHeaders()).map((response: Response) => {
				console.log(response.status);
				const user = response.json();
				user.responseStatus = response.status;
				console.log(user);
				return user;
			}).catch((error) => {
				console.log('error', error);
				if (error.status === 500) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 400) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 401) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				}
			});
	}


	public paginationCI(newOffset, limit) {
		console.log('pagination', newOffset, limit);
		const token = localStorage.getItem('currentUser');
		console.log('token', token);
		const headerToken = 'Bearer ' + token;
		console.log('hk', headerToken);
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', headerToken);
		return this.http.get(environment.baseUrl + '/buyer/invoice',
			{
				headers: headers, params: {
					offset: newOffset,
					limit: limit
				}
			})
			.map((response: Response) => {
				console.log(response.status);
				const user = response.json();
				user.responseStatus = response.status;
				console.log(user);
				return user;
			}).catch((error) => {
				console.log('error', error);
				if (error.status === 500) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 400) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 401) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				}
			});
	}

	public previousPage(previousUrl) {
		console.log('on previous page', previousUrl);
		return this.http.get(environment.baseUrl + '/buyer/invoice' + previousUrl, GlobalService.getHeaders())
			.map((response: Response) => {
				console.log(response.status);
				const user = response.json();
				user.responseStatus = response.status;
				console.log(user);
				return user;
			}).catch((error) => {
				console.log('error', error);
				if (error.status === 500) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 400) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 401) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				}
			});
	}

	public NextPage(nextUrl, newOffset, limit) {
		console.log('on next page', nextUrl, newOffset, limit);
		const token = localStorage.getItem('currentUser');
		console.log('token', token);
		const headerToken = 'Bearer ' + token;
		console.log('hk', headerToken);
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', headerToken);
		return this.http.get(environment.baseUrl + '/buyer/invoice',
			{
				headers: headers, params: {
					offset: newOffset,
					limit: limit
				}
			})
			.map((response: Response) => {
				console.log(response.status);
				const user = response.json();
				user.responseStatus = response.status;
				console.log(user);
				return user;
			}).catch((error) => {
				console.log('error', error);
				if (error.status === 500) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 400) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 401) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				}
			});
	}

	public filterCIByURL(offset: any, limit: any) {
		console.log('href on services', offset, limit);
		const token = localStorage.getItem('currentUser');
		console.log('token', token);
		const headerToken = 'Bearer ' + token;
		console.log('hk', headerToken);
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', headerToken);
		return this.http.get(environment.baseUrl + '/buyer/invoice', {
			headers: headers, params: {
				offset: offset,
				limit: limit
			}
		})
			.map((response: Response) => {
				console.log(response.status);
				const user = response.json();
				user.responseStatus = response.status;
				console.log(user);
				return user;
			}).catch((error) => {
				console.log('error', error);
				if (error.status === 500) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 400) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 401) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				}
			});
	}

	public filterCIOffset() {
		console.log('offset');
		const token = localStorage.getItem('currentUser');
		console.log('token', token);
		const headerToken = 'Bearer ' + token;
		console.log('hk', headerToken);
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', headerToken);
		return this.http.get(environment.baseUrl + '/buyer/invoice',
			{
				headers: headers, params: {
					offset: '0',
					limit: '10'
				}
			})
			.map((response: Response) => {
				console.log(response.status);
				const user = response.json();
				user.responseStatus = response.status;
				console.log(user);
				return user;
			}).catch((error) => {
				console.log('error', error);
				if (error.status === 500) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 400) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 401) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				}
			});
	}


	public searchCI(search) {
		console.log('search', search.searchParam);
		console.log('offset', search.offsteParam);
		console.log('limit', search.limitParam);
		const token = localStorage.getItem('currentUser');
		console.log('token', token);
		const headerToken = 'Bearer ' + token;
		console.log('hk', headerToken);
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', headerToken);
		return this.http.get(environment.baseUrl + '/buyer/invoice',
			{
				headers: headers, params: {
					offset: 0,
					limit: search.limitParam,
					search: search.searchParam
				}
			})
			.map((response: Response) => {
				console.log(response.status);
				const user = response.json();
				user.responseStatus = response.status;
				console.log(user);
				return user;
			}).catch((error) => {
				console.log('error', error);
				if (error.status === 500) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 400) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 401) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				}
			});
	}

	// manual
	public paginationMI(newOffset, MIlimit) {
		console.log('pagination', newOffset, MIlimit);
		const token = localStorage.getItem('currentUser');
		console.log('token', token);
		const headerToken = 'Bearer ' + token;
		console.log('hk', headerToken);
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', headerToken);
		return this.http.get(environment.baseUrl + '/seller/invoice/manual',
			{
				headers: headers, params: {
					offset: newOffset,
					limit: MIlimit
				}
			})
			.map((response: Response) => {
				console.log(response.status);
				const user = response.json();
				user.responseStatus = response.status;
				console.log(user);
				return user;
			}).catch((error) => {
				console.log('error', error);
				if (error.status === 500) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 400) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 401) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				}
			});
	}

	public MIpreviousPage(MIpreviousUrl) {
		console.log('on previous page', MIpreviousUrl);
		return this.http.get(environment.baseUrl + '/seller/invoice/manual' + MIpreviousUrl, GlobalService.getHeaders())
			.map((response: Response) => {
				console.log(response.status);
				const user = response.json();
				user.responseStatus = response.status;
				console.log(user);
				return user;
			}).catch((error) => {
				console.log('error', error);
				if (error.status === 500) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 400) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 401) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				}
			});
	}

	public MINextPage(MInextUrl, MInewOffset, MIlimit) {
		console.log('on next page', MInextUrl, MInewOffset, MIlimit);
		const token = localStorage.getItem('currentUser');
		console.log('token', token);
		const headerToken = 'Bearer ' + token;
		console.log('hk', headerToken);
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', headerToken);
		return this.http.get(environment.baseUrl + '/seller/invoice/manual',
			{
				headers: headers, params: {
					offset: MInewOffset,
					limit: MIlimit
				}
			})
			.map((response: Response) => {
				console.log(response.status);
				const user = response.json();
				user.responseStatus = response.status;
				console.log(user);
				return user;
			}).catch((error) => {
				console.log('error', error);
				if (error.status === 500) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 400) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 401) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				}
			});
	}

	public filterMIByURL(MIoffset: any, MIlimit: any) {
		console.log('href on services', MIoffset, MIlimit);
		const token = localStorage.getItem('currentUser');
		console.log('token', token);
		const headerToken = 'Bearer ' + token;
		console.log('hk', headerToken);
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', headerToken);
		return this.http.get(environment.baseUrl + '/seller/invoice/manual', {
			headers: headers, params: {
				offset: MIoffset,
				limit: MIlimit
			}
		})
			.map((response: Response) => {
				console.log(response.status);
				const user = response.json();
				user.responseStatus = response.status;
				console.log(user);
				return user;
			}).catch((error) => {
				console.log('error', error);
				if (error.status === 500) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 400) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 401) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				}
			});
	}



	public filterMIOffset() {
		console.log('offset');
		const token = localStorage.getItem('currentUser');
		console.log('token', token);
		const headerToken = 'Bearer ' + token;
		console.log('hk', headerToken);
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', headerToken);
		return this.http.get(environment.baseUrl + '/seller/invoice/manual',
			{
				headers: headers, params: {
					offset: '0',
					limit: '10'
				}
			})
			.map((response: Response) => {
				console.log(response.status);
				const user = response.json();
				user.responseStatus = response.status;
				console.log(user);
				return user;
			}).catch((error) => {
				console.log('error', error);
				if (error.status === 500) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 400) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 401) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				}
			});
	}



	public searchMI(search) {
		console.log('search', search.searchParam);
		console.log('offset', search.offsteParam);
		console.log('limit', search.limitParam);
		const token = localStorage.getItem('currentUser');
		console.log('token', token);
		const headerToken = 'Bearer ' + token;
		console.log('hk', headerToken);
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		headers.append('Authorization', headerToken);
		return this.http.get(environment.baseUrl + '/seller/invoice/manual',
			{
				headers: headers, params: {
					offset: 0,
					limit: search.limitParam,
					search: search.searchParam
				}
			})
			.map((response: Response) => {
				console.log(response.status);
				const user = response.json();
				user.responseStatus = response.status;
				console.log(user);
				return user;
			}).catch((error) => {
				console.log('error', error);
				if (error.status === 500) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 400) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 401) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				}
			});
	}

	public approveMI(formdata, statusLimit) {
		console.log(formdata)
		const data = {
			"invoiceId": formdata.invoiceId,
			"sellerId": formdata.sellerId,
			"status": statusLimit,
			"acceptanceCriteria": true,
			"rejectionRemarks": ""
		};
		console.log('data', data);
		const body = JSON.stringify(data);
		console.log(body);
		return this.http.post(environment.baseUrl + '/buyer/manual_invoice',
			body, GlobalService.getHeaders()).map((response: Response) => {
				console.log(response.status);
				const user = response.json();
				user.responseStatus = response.status;
				console.log(user);
				return user;
			}).catch((error) => {
				console.log('error', error);
				if (error.status === 500) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 400) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 401) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				}
			});
	}

	public rejectMI(formdata, statusLimit) {
		console.log(formdata)
		const data = {
			"invoiceId": formdata.invoiceId,
			"sellerId": formdata.sellerId,
			"status": statusLimit,
			"acceptanceCriteria": false,
			"rejectionRemarks": ""
		};
		console.log('data', data);
		const body = JSON.stringify(data);
		console.log(body);
		return this.http.post(environment.baseUrl + '/buyer/manual_invoice',
			body, GlobalService.getHeaders()).map((response: Response) => {
				console.log(response.status);
				const user = response.json();
				user.responseStatus = response.status;
				console.log(user);
				return user;
			}).catch((error) => {
				console.log('error', error);
				if (error.status === 500) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 400) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				} else if (error.status === 401) {
					console.log('status', error.status);
					const err = error.json();
					err.responseStatus = error.status;
					console.log('status', err.responseStatus);
					return Observable.throw(err);
				}
			});
	}

	public getDigitalInvoiceStatus(payload: { invoiceId: string, amount: string, currency: string, sellerId: string }) {
		const body = JSON.stringify(payload);

		return this.http.post(
			environment.baseUrl + "/buyer/digital_invoice_status",
			body,
			GlobalService.getHeaders()
		)
			.map((res: Response) => {
				const response = res.json();
				console.log("[BuyerInvoiceService getDigitalInvoiceStatus] response", response);
				return response;
			})
			.catch((err: any, _: Observable<void>) => {
				const error = err.json();
				console.log("[BuyerInvoiceService getDigitalInvoiceStatus] error", error);
				return Observable.throw(err);
			});
	}

	public digitalInvoicePayment(payload: { invoiceId: string, amount: string, orderId: string, sellerId: string }) {
		const body = JSON.stringify(payload);
		
		return this.http.post(
			environment.baseUrl + "/buyer/digital_invoice_payment",
			body,
			GlobalService.getHeaders()
		)
			.map((res: Response) => {
				const response = res.json();
				console.log("[BuyerInvoiceService digitalInvoicePayment] response", response);
				return response;
			})
			.catch((err: any, _: Observable<void>) => {
				const error = err.json();
				console.log("[BuyerInvoiceService digitalInvoicePayment] error", error);
				return Observable.throw(err);
			});
	}

	public manualInvoicePayment(payload: { invoiceId: string, amount: string, orderId: string, sellerId: string }) {
		console.log("[BuyerInvoiceService manualInvoicePayment] payload", payload);
		
		const body = JSON.stringify(payload);
		
		return this.http.post(
			environment.baseUrl + "/buyer/manual_invoice_payment",
			body,
			GlobalService.getHeaders()
		)
			.map((res: Response) => {
				const response = res.json();
				console.log("[BuyerInvoiceService manualInvoicePayment] response", response);
				return response;
			})
			.catch((err: any, _: Observable<void>) => {
				const error = err.json();
				console.log("[BuyerInvoiceService manualInvoicePayment] error", error);
				return Observable.throw(err);
			});
	}

	public getManualInvoiceStatus(payload: { invoiceId: string, amount: string, currency: string, sellerId: string }) {
		const body = JSON.stringify(payload);

		return this.http.post(
			environment.baseUrl + "/buyer/manual_invoice_status",
			body,
			GlobalService.getHeaders()
		)
			.map((res: Response) => {
				const response = res.json();
				console.log("[BuyerInvoiceService getManualInvoiceStatus] response", response);
				return response;
			})
			.catch((err: any, _: Observable<void>) => {
				const error = err.json();
				console.log("[BuyerInvoiceService getManualInvoiceStatus] error", error);
				return Observable.throw(err);
			});
	}

	public  manualExcelUpload(Image) {
		console.log('image', Image);
		const form = new FormData();
		form.append('file', Image);
		return this.http.post(environment.baseUrl + '/user/manual_invoice_excel_upload', form, GlobalService.getInvHeaders()).map((response: Response) => {
		  console.log(response.status);
		  const user = response.json();
		  user.responseStatus = response.status;
		  console.log(user);
		  return user;
		});
	  }
}
